import { render, staticRenderFns } from "./DateTag.vue?vue&type=template&id=59f86658&scoped=true&"
import script from "./DateTag.vue?vue&type=script&lang=js&"
export * from "./DateTag.vue?vue&type=script&lang=js&"
import style0 from "./DateTag.vue?vue&type=style&index=0&id=59f86658&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f86658",
  null
  
)

export default component.exports